import React from "react";
import { useSelector } from "react-redux";

import Pendo from "@cayuse/shared-react.components.pendo";

import { PENDO_API_KEY, PENDO_PRODUCT_NAME, ZENDESK_KEY } from "globals/constants";
import { shellSelectors, tenantSelectors } from "store/selectors";

const PendoComponent = () => {
	const { userId } = useSelector(shellSelectors.cayuseHeader);
	const { contactEmail } = useSelector(shellSelectors.user);
	const { hostname } = useSelector(tenantSelectors.tenant);

	return (
		<Pendo
			apiKey={PENDO_API_KEY}
			product={PENDO_PRODUCT_NAME}
			userId={userId}
			email={contactEmail}
			hostname={hostname}
			zendeskKey={ZENDESK_KEY}
		/>
	);
};

export default PendoComponent;
